<template>
    <div class="content">
        <headers :title='titles'></headers>
        <div v-if="!firstLoad">
            <div v-if="Object.keys(book).length==0">
                <div class="box">
                    <p class="p1"></p>
                    <p class="p2">您暂未设置<em>教材</em></p>
                    <p class="p3">请设置一本<em>教材</em>吧，设置过后才能布置作业</p>
                    <a href="javascript:;"
                       class="set-book"
                       @click="setbook">设置教材</a>
                </div>
            </div>
            <div v-else>
                <div class="title">
                    <div>
                        <p></p>
                        <p>{{book.name.slice(-5)}}（{{book.press_name}}）</p>
                        <p @click="setbook">更换<em>教材</em></p>
                        <p></p>
                    </div>
                </div>
                <div class="main"
                     v-if="list.length>0">
                    <div class="main_box"
                         v-for="(i,index) in list">
                        <div class="main_title"
                             @click="open(i,index)">
                            <p><i></i></p>
                            <p>{{index+1}}.{{i.name}}</p>
                            <!--<p :class="i.choise ? 'list_active' : 'list_noactive'"></p>-->
                            <p :class="i.choise ? 'list_open' : 'list_close'"
                               v-if="i.children.length >0"></p>
                        </div>
                        <transition name="my-slide"
                                    tag="div">
                            <div class="main_con_wrap"
                                 v-show="!i.choise"
                                 :style="`height:${i.children.length * 2.4}rem`">
                                <div class="main_con"
                                     v-for="q,inx in i.children">
                                    <p>{{q.name}}</p>
                                    <p @click='select(q,index,inx)'>
                                        <img v-if='q.is_select'
                                             src="./img/icon_select.png"
                                             alt="">
                                        <img src="./img/icon_unchecked.png"
                                             alt=""
                                             v-else>
                                    </p>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
                <div v-else>
                    <noResouse></noResouse>
                </div>
            </div>
        </div>
        <div v-else>
            <loading></loading>
        </div>
        <div class="foot"
             v-if="Object.keys(book).length!=0 && list.length">
            <div class="bottom_btn">
                <a v-if='next_btn'
                   class="btn_a"
                   @click='next'>下一步</a>
                <a v-else>下一步</a>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import { mapState } from 'vuex';
import loading from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue'
import headers from 'COMPONENTS/base/header.vue'

export default {
    data () {
        return {
            // subject_id: this.$route.params.type,
            // book_type: this.$route.query.bookType,
            hasbook: false,
            firstLoad: true,
            list: [],
            book: [],
            titles: '课文预习',
            qid: [],
            catalogId: null,//章节id
            next_btn: false,
            code: null,
            val: null,
            tit: null,
            ch_id: null,
        }
    },
    components: {
        loading,
        noResouse,
        headers
    },
    computed: {},
    async created () {
        let _sendok = localStorage.getItem('chinese_send_ok');
        // //console.log(_sendok)
        if (_sendok == 1) {
            this.$router.go(-1);//发布过返回选内容
        } else {
            let o = {
                sid: 51,
                book_type: 0,
                code: '007'
            }
            await this.$http.post(API_URL_TASK_API + '/public/book/user_book', o).then(resp => {
                let res = resp.data;
                if (res.response === 'ok') {
                    this.$store.state.book = res.data;
                    this.book = res.data;
                }
            })
            if (Object.keys(this.book).length != 0) {
                await this.getlist();
            } else {
                this.firstLoad = false
            }
        }
    },
    methods: {
        setbook () {
            //book_type:1
            /*'/setBook/:subject/:type/:code'*/
            /**
             *路由参数要修改
             ***/
            this.$router.push('/setBook/51/1/7')
        },
        getlist () {
            if (Object.keys(this.book).length != 0) {
                this.$http.post(API_URL_TASK_API + '/chinese/check/chapter/list', {
                    book_id: this.book.id
                }).then(resp => {
                    let res = resp.data;
                    this.firstLoad = false
                    if (res.response === 'ok') {
                        this.list = res.data;
                        this.list.forEach((l, index) => {
                            l.choise = true;
                            l.children.forEach((m, n) => {
                                m.is_select = false
                            })
                        })
                    }
                })
            } else {
                this.firstLoad = false
            }
        },
        open (i, ind) {
            // this.list.forEach((l,ix)=>{
            //   if(ix == ind){
            //     this.list[ind].choise = !this.list[ind].choise;
            //   }else{
            //     l.choise = true;
            //   }
            // })
            this.list[ind].choise = !this.list[ind].choise;
            this.list.splice(ind, 1, i)
            this.catalogId = i.value;
        },
        select (q, index, inx) {
            this.code = q.code;
            this.val = q.value;
            this.tit = q.name;
            this.ch_id = q.ch_id;
            if (q.is_select) {
                q.is_select = false;
                let _index = this.qid.findIndex(q => q == q.value);
                this.qid.splice(_index, 1)
            } else {
                this.list.forEach((m, n) => {
                    m.children.forEach((l, i) => {
                        l.is_select = false
                    })
                })
                q.is_select = true;
                this.qid.push(q.value);
            }

            this.list[index].children.splice(inx, 1, q)
            if (this.qid.length > 0) {
                this.next_btn = true;
            } else {
                this.next_btn = false;
            }
        },
        next () {
            let gradeid = this.book.grade_id;
            // this.$store.commit('setKnowledgeid',this.qid)
            //'/chinese/before/preview/:gradeid/:code/:value'
            // this.$router.push('/chinese/before/preview/' + gradeid + '/' + this.code + '/' + this.val + '?title=' + this.tit)
            this.$router.push(`/chinese/before/preview/${gradeid}/${this.code}/${this.val}?ch_id=${this.ch_id}&title=${this.tit}`)
        },
        back () {
            this.$router.go(-1)
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

.set-book {
    display: block;
    margin: 40px / $ppr auto 0 auto;
    width: 360px / $ppr;
    height: 82px / $ppr;
    line-height: 82px / $ppr;
    font-size: 30px / $ppr;
    color: #fff;
    background: #5e89ef;
    border-radius: 41px / $ppr;
    text-align: center;
}

.content {
    width: 100%;
    min-height: 100vh;
    padding-bottom: 96px / $ppr;
    box-sizing: border-box;
    .title {
        width: 100%;
        height: 96px / $ppr;
        margin-bottom: 24px / $ppr;
        background: #fff;
        div {
            width: 673px / $ppr;
            height: 96px / $ppr;
            margin: 0 auto;
            p {
                line-height: 96px / $ppr;
                text-align: left;
            }
            p:nth-child(1) {
                width: 34px / $ppr;
                height: 34px / $ppr;
                background: url("img/icon_setbook.png") no-repeat;
                -webkit-background-size: 100% 100%;
                background-size: 100% 100%;
                float: left;
                margin: 31px / $ppr 24px / $ppr 0 0;
            }
            p:nth-child(2) {
                width: 462px / $ppr;
                float: left;
                font-size: 30px / $ppr;
                color: #333;
                @include ellipsis;
            }
            p:nth-child(3) {
                width: 139px / $ppr;
                color: #5e89ef;
                font-size: 30px / $ppr;
                float: left;
            }
            p:nth-child(4) {
                width: 14px / $ppr;
                height: 26px / $ppr;
                float: right;
                margin-top: 34px / $ppr;
                background: url("./img/enter.png") no-repeat;
                -webkit-background-size: 100% 100%;
                background-size: 100% 100%;
            }
        }
    }
    .main {
        width: 100%;
        height: auto;
        background: #fff;
        .main_box {
            width: 100%;
            height: auto;
            .main_title {
                width: 100%;
                height: 96px / $ppr;
                border-bottom: 1px / $ppr solid #e8e8e8;
                p:nth-child(1) {
                    width: 80px / $ppr;
                    height: 96px / $ppr;
                    float: left;
                    i {
                        display: block;
                        width: 34px / $ppr;
                        height: 32px / $ppr;
                        background: url("img/icon_book.png") no-repeat;
                        -webkit-background-size: 100% 100%;
                        background-size: 100% 100%;
                        margin: 32px / $ppr 22px / $ppr 0 24px / $ppr;
                    }
                }
                p:nth-child(2) {
                    width: 556px / $ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    font-size: 30px / $ppr;
                    color: #333;
                    float: left;
                    text-align: left;
                    @include ellipsis;
                }
                .list_open {
                    width: 25px / $ppr;
                    height: 13px / $ppr;
                    background: url("img/icon_open.png") no-repeat;
                    -webkit-background-size: 100% 100%;
                    background-size: 100% 100%;
                    float: right;
                    margin: 41px / $ppr 24px / $ppr 0 0;
                }
                .list_close {
                    width: 25px / $ppr;
                    height: 13px / $ppr;
                    background: url("img/icon_close.png") no-repeat;
                    -webkit-background-size: 100% 100%;
                    background-size: 100% 100%;
                    float: right;
                    margin: 41px / $ppr 24px / $ppr 0 0;
                }
            }
            .main_con {
                width: 100%;
                height: 96px / $ppr;
                background: #f0f0f0;
                border-bottom: 1px / $ppr solid #e8e8e8;
                p {
                    float: left;
                    box-sizing: border-box;
                }
                p:nth-child(1) {
                    width: 450px / $ppr;
                    margin-left: 106px / $ppr;
                    line-height: 96px / $ppr;
                    color: #333;
                    font-size: 30px / $ppr;
                    text-align: left;
                    @include ellipsis;
                }
                p:nth-child(2) {
                    width: 80px / $ppr;
                    height: 100%;
                    text-align: center;
                    color: #5e89ef;
                    font-size: 28px / $ppr;
                    position: relative;
                    left: 80px / $ppr;
                    img {
                        width: 45px / $ppr;
                        height: 45px / $ppr;
                        position: relative;
                        top: 25px / $ppr;
                        // left:5px/$ppr;
                    }
                }
            }
        }
    }
}

.box {
    //无教材
    width: 100%;
    height: auto;
    margin-top: 325px / $ppr;
    p {
        display: block;
    }
    .p1 {
        width: 136px / $ppr;
        height: 112px / $ppr;
        background: url("img/icon_nobook.png") no-repeat;
        -webkit-background-size: 100% 100%;
        background-size: 100% 100%;
        margin: 0 auto;
    }
    .p2 {
        width: 100%;
        text-align: center;
        color: #333;
        font-size: 36px / $ppr;
        line-height: 36px / $ppr;
        margin: 40px / $ppr 0 16px / $ppr 0;
    }
    .p3 {
        width: 100%;
        text-align: center;
        color: #999;
        font-size: 24px / $ppr;
        line-height: 24px / $ppr;
        margin-bottom: 40px / $ppr;
    }
    .p4 {
        width: 360px / $ppr;
        height: 82px / $ppr;
        margin: 0 auto;
        border-radius: 40px / $ppr;
        background: #5e89ef;
        font-size: 34px / $ppr;
        color: #fff;
        line-height: 82px / $ppr;
    }
}

.foot {
    position: fixed;
    bottom: 0;
    width: 100%;
    .bottom_btn {
        a {
            display: inline-block;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            width: 100%;
            color: #999999;
            background-color: $line;
            text-align: center;
            font-size: 36px / $ppr;
            //font-weight: bold;
            &.btn_a {
                color: #fff;
                background-color: #5e89ef;
            }
        }
    }
    .bottom_btn2 {
        a {
            display: inline-block;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            width: 100%;
            color: $c-header;
            background-color: $c-theme;
            text-align: center;
            font-size: $lg;
        }
    }
}
.main_con_wrap {
    height: 0;
    overflow: hidden;
    transition: height 0.3s linear;
}
.my-slide-enter,
.my-slide-leave-to {
    height: 0 !important;
}
</style>
